import customAxios from './axios';
import CONFIG from '../../config';

export const createNotification = (payload) => {
    return customAxios.post(CONFIG.apiURL + `/FlyerNoti/Send`, payload).then((res) => {
        return res;
    });
};

export const uploadBanner = (payload) => {
    return customAxios.post(CONFIG.documentURL + '/DocumentVault/Banner/UploadBanner', payload).then(res => {
        let response = res['data'];
        return response;
    })
};

export const getProcess = () => {
    return customAxios.get(CONFIG.apiURL + '/MasterProcesses/Process').then(res => {
        return res['data'];
    })
};